import React from 'react';

import { Grid } from 'components/grid';
import { Toggle } from 'components/toggle';
import PropTypes from 'prop-types';

import './ToggleCard.scss';

const ToggleCard = ({
  title,
  description,
  label,
  children,
  toggleProps,
  checked
}) => (
  <Grid block className="toggle_card">
    <Grid.Title data-test="card-title">{title}</Grid.Title>
    <div className="toggle_card__description" data-test="card-description">
      {description}
    </div>
    <div className="toggle_card__container" data-test="card-toggle">
      <label data-test="toggle-label" className="toggle_card__label">
        {label}
      </label>
      <Toggle {...toggleProps} checked={checked} />
    </div>
    {children}
  </Grid>
);

ToggleCard.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  label: PropTypes.node,
  children: PropTypes.node,
  checked: PropTypes.bool,
  toggleProps: PropTypes.object
};

export default React.memo(ToggleCard);
